import { useTranslation } from "react-i18next";
import { Button } from "../../../common/components/Button";
import { PreviewGlassMagnifier } from "../../../containers/StudioSidebarContainer/StudioRightSidebar/DecorationRightSidebar/PreviewGlassMagnifier";
import { UploadImageButton } from "../../UploadImage/UploadImageButton";
import { UploadImageDropZone } from "../../UploadImage/UploadImageDropZone";
import { GLASS_MAGNIFIER_BACKGROUND_COLORS } from "../../../types";
import { Box, FlexColBox } from "../../../common/components";
import { Typography } from "@mui/material";

interface Props {
  imageUrl: string;
  title: string;
  backgroundColor: GLASS_MAGNIFIER_BACKGROUND_COLORS;
  errorCode: string | null;
  onDownloadUrl?: () => void;
  onUpload?: (options: any) => void;
  onRemove?: () => void;
  onBackgroundColorChange: (color: string) => void;
  allowDownload?: boolean;
  allowOpenInNewTab?: boolean;
  allowReplace?: boolean;
  allowRemove?: boolean;
  noBackgroundColor?: boolean;
  allowLightGrey?: boolean;
  allowWhite?: boolean;
}

const TechpackArtworkImage = (props: Props) => {
  const {
    imageUrl,
    title,
    backgroundColor,
    errorCode,
    onDownloadUrl,
    onUpload,
    onRemove,
    onBackgroundColorChange,
    allowDownload = false,
    allowOpenInNewTab = false,
    allowReplace = false,
    allowRemove = false,
    noBackgroundColor = false,
    allowLightGrey = false,
  } = props;
  const acceptedFileExtensions = ["AI", "EPS", "SVG", "PNG", "JPG"];

  const { t } = useTranslation();

  return (
    <FlexColBox gap={1} alignItems="center">
      {imageUrl ? (
        <Box fullWidth>
          <PreviewGlassMagnifier
            imageUrl={imageUrl}
            title={title}
            allowWhite={true}
            backgroundColor={backgroundColor}
            noBackgroundColor={noBackgroundColor}
            onBackgroundColorChange={onBackgroundColorChange}
            hideZoom={true}
            imageMaxHeight={"464px"}
            allowLightGrey={allowLightGrey}
          />
        </Box>
      ) : (
        allowReplace &&
        onUpload && (
          <FlexColBox gap={1} width="100%">
            <Typography variant="textRegularBold">{title}</Typography>
            <UploadImageDropZone
              onUpload={onUpload}
              errorCode={errorCode}
              acceptedFilesTitle={""}
              acceptedFileExtensions={acceptedFileExtensions}
            />
          </FlexColBox>
        )
      )}
      <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
        {allowDownload && onDownloadUrl && (
          <Button onClick={onDownloadUrl} variant="outlined" size="small">
            {t("general.download")}
          </Button>
        )}
        {imageUrl && allowOpenInNewTab && (
          <Button
            onClick={() => window.open(imageUrl, "_blank")}
            variant="outlined"
            size="small"
          >
            {t("techpack.open_new_tab")}
          </Button>
        )}
        {imageUrl && allowReplace && onUpload && (
          <UploadImageButton
            title={t("techpack.replace")}
            onUpload={onUpload}
            errorCode={errorCode}
            acceptedFilesTitle={""}
            acceptedFileExtensions={acceptedFileExtensions}
            size="small"
          />
        )}
        {imageUrl && allowRemove && (
          <Button
            onClick={onRemove}
            variant="outlined"
            color="error"
            size="small"
          >
            {t("general.remove")}
          </Button>
        )}
      </Box>
    </FlexColBox>
  );
};

export default TechpackArtworkImage;
